import React from 'react'

import {ParsedUrlQuery} from 'querystring'
import {InstantSearchServerState} from 'react-instantsearch'

import {AlgoliaProvider} from './context/AlgoliaContext'
import CategoryResults from './CategoryResults'

export interface Props {
  id?: number
  title?: string
  attrNameMap: Record<string, string>
  initialQuery: ParsedUrlQuery
  serverState?: InstantSearchServerState | object
}

export default function AlgoliaPage({
  id,
  title,
  attrNameMap,
  initialQuery,
  serverState,
}: Props) {
  return (
    <AlgoliaProvider
      id={id}
      attrNameMap={attrNameMap}
      initialQuery={initialQuery}
      serverState={serverState}
    >
      <CategoryResults id={id} title={title} attrNameMap={attrNameMap} />
    </AlgoliaProvider>
  )
}
